export const Marquee = ({ items }) => (
  <div
    className="relative overflow-hidden border-y border-sand/70 bg-beige/50 py-5"
    data-testid="marquee"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="whitespace-nowrap px-6 sm:px-10 font-grotesk text-xs sm:text-sm font-medium uppercase tracking-[0.32em] text-espresso/70">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-teak/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
